export { default } from './Map'



// WEBPACK FOOTER //
// ./src/Map/index.js